export default __webpack_public_path__ + "static/media/student-profile-livvy-image.d873106c.svg";